import { render, staticRenderFns } from "./doctor-codes-dialog.vue?vue&type=template&id=fd251a88&scoped=true&"
import script from "./doctor-codes-dialog.vue?vue&type=script&lang=js&"
export * from "./doctor-codes-dialog.vue?vue&type=script&lang=js&"
import style0 from "./doctor-codes-dialog.vue?vue&type=style&index=0&id=fd251a88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd251a88",
  null
  
)

component.options.__file = "doctor-codes-dialog.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VCardTitle,VDialog,VDivider,VSpacer})
